import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';

/* global customElements */
class RoutingPipelineTool extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
						
		var routingTool = this;
		setTimeout(function(){
			routingTool.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var routingTool = this;

		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',					
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Create Locations')
					], 
					listeners: {
						click: function() {
							actionRoute();
						}
					}
				},
				{									
					tag: 'div',
					style: 'float: right',
					children:[
						{
							tag: 'vaadin-button',																								
							'class': 'spacer-toolbar-item',
							style: '',
							children:[
								ElementUtil.makeIcon('vaadin:cog', ' Options')
							],
							listeners: {
								click: function() {
									actionRouteOptions();
								}
							}
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'vaadin-button',						
							theme: 'primary',												
							'class': 'spacer-toolbar-item',
							style: '',
							children:[
								ElementUtil.makeIcon('vaadin:upload', ' Bulk Upload')
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}
						}
					]
				}				
			]
		});		
		
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [							
				{						
					path: 'field',
					header: 'Field',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.highlight) {
							root.style = 'background-color: rgb(88 124 137); color: white;';
						} else {
							root.style.backgroundColor = '';
						}
						root.innerHTML = rowData.item.field;
					}
				},	
				{						
					path: 'value',
					header: 'Value',
					width: '7em'
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				}
			}
		});	
				
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'routingPipelineTool',
			showDetail: false
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		routingTool.append(flexLayout);	
				
		var actionRoute = function() {
			
			//pop up with form and grid (form should add point to grid)			
			var routeWin = ElementUtil.create({			
				tag: 'dl-dialog',
				title: 'Add Locations',
				icon: 'vaadin:upload',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						routeWin.show();
						
						var locations = [];
						
						var locationGridToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',							
							children: [
								{
									tag: 'vaadin-button',
									itemid: 'add',
									theme: 'primary',
									'class': 'spacer-toolbar-item',													
									children:[
										ElementUtil.makeIcon('vaadin:plus', ' Add')						
									],
									listeners: {
										click: function() {
											actionAddEditLocation();
										}
									}					
								},
								{
									tag: 'vaadin-button',
									itemid: 'edit',
									'class': 'spacer-toolbar-item',
									disabled: true,										
									children:[
										ElementUtil.makeIcon('vaadin:edit', ' Edit')						
									],
									listeners: {
										click: function() {
											actionAddEditLocation(locationGrid.selectedItems[0]);
										}
									}					
								},
								{
									tag: 'div',
									style: 'float: right;',
									children:[											
										{
											tag: 'vaadin-button',
											itemid: 'delete',
											disabled: true,
											theme: 'error primary',
											'class': 'spacer-toolbar-item',																						
											children:[
												ElementUtil.makeIcon('vaadin:trash', 'Remove')						
											],
											listeners: {
												click: function() {
													actionDeleteLocation(locationGrid.selectedItems[0]);
												}
											}							
										}
									]
								}											
							]
						});	
						
						var locationGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'wrap-cell-content row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							'rows-draggable': true,
							'drop-mode': 'between',	
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true,
								listeners: {
									'direction-changed': function (event) {
										if (event.detail && event.detail.value) {
											locationGrid.currentSortField = event.target.path;
											locationGrid.currentSortDirection = event.detail.value.toUpperCase();										
										}
									}
								}
							},
							children: [
								{
									path: 'address',
									header: 'Address',
									width: '7em'
								},
								{
									path: 'city',
									header: 'City',
									width: '9em'
								},
								{
									path: 'state',
									header: 'State/Prov',
									width: '7em'
								},
								{
									path: 'latitude',
									header: 'Latitude',
									width: '7em'
								},
								{
									path: 'longitude',
									header: 'Longitude',
									width: '7em'
								},
								{
									path: 'odometer',
									header: 'Odometer',
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									locationGrid.selectedItems = item ? [item] : [];
									if (locationGrid.selectedItems.length > 0) {
										ElementUtil.query(locationGridToolbar, 'edit').disabled = false;
										ElementUtil.query(locationGridToolbar, 'delete').disabled = false;
									} else {
										ElementUtil.query(locationGridToolbar, 'edit').disabled = true;
										ElementUtil.query(locationGridToolbar, 'delete').disabled = true;
									}
								}
							}
						});						

						var locationBottomToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'footer',
							theme: 'spacing',							
							children: [
								{
									tag: 'div',
									style: 'text-align: center;',
									children: [
										{
											tag: 'vaadin-button',
											theme: 'primary',
											'class': 'spacer-toolbar-item',
											children: [
												ElementUtil.makeIcon('vaadin:road', ' Route')
											],
											listeners: {
												click: function () {
													if (locations.length < 2) {
														window.DL.MessageUtil.showOkMessage('At least 2 Locations required.');
													} else {
														//create submit model
														var request = {
															locations: []
														};
														
														if (routingTool.routeOptions) {
															request.engineOptions = routingTool.routeOptions;
														}
														
														locations.forEach(function(location){
															request.locations.push({
																location: {
																	addressLine1: location.address,
																	city: location.city,
																	stateProv: location.state,
																	latitude: location.latitude,
																	longitude: location.longitude																	
																},
																odometer: {
																	odometer: location.odometer,
																	odometerUom: 'MI'
																}
															});
														});
														
														//run route
														var loadMask = routeWin.showLoading('Routing...');
														RoutingService.getRoutingToolsService().routingPipeline(request).then(function (results) {
															loadMask.remove();
															
															var keyValue = [];

															if (results.calcResultModel &&
																results.calcResultModel.details &&
																results.calcResultModel.details.length > 0) {

																results.calcResultModel.details.forEach(function (detail) {
																	keyValue.push({
																		field: 'Failure Message - ' + detail.levelLog,
																		value: detail.message
																	});
																});
															} else {
																var locationId = 1;
																results.unitLocations.forEach(function (unitLocation) {
																	keyValue.push({
																		field: (locationId++) + ' Location',
																		value: (unitLocation.location.addressLine1 ? unitLocation.location.addressLine1 + ', ' : '') + unitLocation.location.city + ', ' + unitLocation.location.stateProv + ', ' + unitLocation.location.latitude + ', ' + unitLocation.location.longitude,
																		highlight: true																		
																	});

																	var totalRecord = {
																		total: 0,
																		toll: 0,
																		tollAmount: 0,
																		ferry: 0
																	};
																	unitLocation.distance.distances.forEach(function (detail) {
																		keyValue.push({
																			field: 'State',
																			value: detail.stateProv,
																			highlight: true
																		});
																		keyValue.push({
																			field: 'Country',
																			value: detail.country
																		});
																		keyValue.push({
																			field: 'Total Miles (Original)',
																			value: Math.round(detail.originalDistance.distance * 10) / 10
																		});
																		keyValue.push({
																			field: 'Toll Miles (Original)',
																			value: Math.round(detail.originalDistance.tollDistance * 10) / 10
																		});
																		keyValue.push({
																			field: 'Toll Amount (Original)',
																			value: StringUtil.currencyFormat(detail.originalDistance.tollExpense)
																		});
																		keyValue.push({
																			field: 'Ferry Miles (Original)',
																			value: Math.round(detail.originalDistance.ferryDistance * 10) / 10
																		});

																		keyValue.push({
																			field: 'Total Miles (Final)',
																			value: Math.round(detail.finalDistance.distance * 10) / 10
																		});
																		keyValue.push({
																			field: 'Toll Miles (Final)',
																			value: Math.round(detail.finalDistance.tollDistance * 10) / 10
																		});
																		keyValue.push({
																			field: 'Toll Amount (Final)',
																			value: StringUtil.currencyFormat(detail.finalDistance.tollExpense)
																		});
																		keyValue.push({
																			field: 'Ferry Miles (Final)',
																			value: Math.round(detail.finalDistance.ferryDistance * 10) / 10
																		});

																		totalRecord.total += detail.finalDistance.distance;
																		totalRecord.toll += detail.finalDistance.tollDistance;
																		totalRecord.tollAmount += detail.finalDistance.tollExpense;
																		totalRecord.ferry += detail.finalDistance.ferryDistance;
																	});

																	keyValue.push({
																		field: 'Total (Final)',
																		value: '',
																		highlight: true
																	});
																	keyValue.push({
																		field: 'Total Miles',
																		value: Math.round(totalRecord.total * 10) / 10
																	});
																	keyValue.push({
																		field: 'Toll Miles',
																		value: Math.round(totalRecord.toll * 10) / 10
																	});
																	keyValue.push({
																		field: 'Toll Amount',
																		value: StringUtil.currencyFormat(totalRecord.tollAmount)
																	});
																	keyValue.push({
																		field: 'Ferry Miles',
																		value: Math.round(totalRecord.ferry * 10) / 10
																	});
																});
															}

															grid.items = keyValue;													
																														
															routeWin.close();															
														}, function(error) {
															loadMask.remove();
														});			
													}
												}
											}
										},
										{
											tag: 'vaadin-button',
											theme: 'tertiary',
											'class': 'spacer-toolbar-item',
											innerHTML: 'Cancel',
											listeners: {
												click: function () {
													routeWin.close();
												}
											}
										}	
									]
								}																				
							]
						});	

						var locationFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								locationGridToolbar,
								locationGrid,
								locationBottomToolbar
							]
						});
							
						routeWin.addToContentElement(locationFlexLayout);
						
						var actionRefreshLocations = function() {	
							locationGrid.items = locations.slice();														
						};
						actionRefreshLocations();
						
						var actionAddEditLocation = function(location) {
						
							var addEditLocationWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: location ? 'Edit Location: ' + location.city + ', ' + location.state : 'Add Location',
								icon: 'vaadin:edit',
								width: 800,
								height: 225,
								listeners: {
									ready: function () {
										addEditLocationWin.show();

										var formPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'dl-location-lookup',
													itemid: 'locationLookupStart',
													label: 'Location',
													name: 'locationStart',
													textstyle: 'width: 250px',
													style: 'margin-left: 10px;',
													required: true
												},														
												{
													tag: 'vaadin-number-field',
													name: 'odometer',
													label: 'Odometer (miles)',															
													min: 0,
													max: 999999999
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:plus', (location ? ' Update Location' : ' Add Location'))
																	],
																	listeners: {
																		click: function () {
																			
																			if (formPanel.isValid()) {
																				var data = formPanel.getData(); 

																				var loadMask = formPanel.showLoading('Checking Location');
																				RoutingService.getRoutingToolsService().geocode({
																					rawLocation: data.locationStart
																				}).then(function(startArray) {
																					var start = startArray[0];			
																					if (!start.latitude || !start.longitude) {	
																						var locationStartField = ElementUtil.query(formPanel, 'locationLookupStart');

																						locationStartField.markError('Invaild location');
																						loadMask.remove();
																					} else {
																						if (location) {
																							location.address = start.address1;
																							location.city = start.city;
																							location.state = start.state;
																							location.latitude = start.latitude;
																							location.longitude = start.longitude;
																							location.odometer = data.odometer;
																						} else {
																							locations.push({
																								address: start.address1,
																								city: start.city,
																								state: start.state,
																								latitude: start.latitude,
																								longitude: start.longitude,
																								odometer: data.odometer
																							});
																						}
																						actionRefreshLocations();
																						addEditLocationWin.close();																				
																					}
																				});																			
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			//cancel
																			addEditLocationWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});

										addEditLocationWin.addToContentElement(formPanel);

										if (location) {
											var hasAddress = !!location.address;
											var hasLatLong = location.latitude && location.longitude;
											var loadModel = {
												locationStart: location.latitude + ', ' + location.longitude,
												odometer: location.odometer
											};
											if (hasAddress) {
												var addressLocationParts = [location.address];
												if (location.city) {
													addressLocationParts.push(location.city);
												}
												if (location.state) {
													addressLocationParts.push(location.state);
												}
												loadModel.locationStart = addressLocationParts.join(', ');
											} else if (hasLatLong) {
												loadModel.locationStart = location.latitude + ', ' + location.longitude;
											} else if (location.city && location.state) {
												loadModel.locationStart = location.city + ', ' + location.state;
											}
											setTimeout(function(){
												formPanel.load(loadModel);
												var locationLookup = ElementUtil.query(formPanel, 'locationLookupStart');
												var locationTextField = locationLookup ? ElementUtil.query(locationLookup, 'text') : null;
												if (locationTextField) {
													if (hasAddress && hasLatLong) {
														locationTextField.helperText = location.latitude + ', ' + location.longitude;
													} else if (!hasAddress && hasLatLong) {
														var locationHelperParts = [];
														if (location.city) {
															locationHelperParts.push(location.city);
														}
														if (location.state) {
															locationHelperParts.push(location.state);
														}
														locationTextField.helperText = locationHelperParts.join(' ');
													} else {
														locationTextField.helperText = '';
													}
												}
											}, 100);											
										}
									}
								}
							});
						};
						
						var actionDeleteLocation = function(location) {							
							window.DL.MessageUtil.showConfirm({
								title: 'Confirm Delete',
								message: 'Are you sure you want to delete selected location?',
								buttons: [
									{
										text: 'Yes',
										handler: function() {
											
											var locationToKeep = [];
											locations.forEach(function(item){
												var keep = true;
												if (location.latitude === item.latitude && 
													location.longitude === item.longitude && 
													location.odometer === item.odometer) {												
													keep = false;
												}
												if (keep) {
													locationToKeep.push(item);
												}
											});
											locations = locationToKeep;
											actionRefreshLocations();
					
										}
									},
									{
										text: 'No'
									}
								]
							});							
							
						};
						
					}
				}
			});
		
			
		};
		
		var actionUpload = function() {
			
			var uploadWin = ElementUtil.create({			
				tag: 'dl-dialog',
				title: 'Bulk Upload',
				icon: 'vaadin:upload',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var primaryToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'div',
									innerHTML: 'Format: Text - route per line Origin TAB Odometer'									
								},
								{
									tag: 'vaadin-button',			
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:upload', ' Upload')
									], 
									listeners: {
										click: function() {
											actionShowUploadForm();
										}
									}
								},	
								{
									tag: 'hr'
								}
							]

						});
						
						var outputGrid = ElementUtil.create({
							tag: 'dl-backgroundoutput-grid',
							category: 'ROUTING',
							slot: 'primary'							
						});
						
						
						var flexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								outputGrid,
								primaryToolbar
							]
						});
						uploadWin.addToContentElement(flexLayout);
						
						var actionShowUploadForm = function() {
							
							var uploadWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Import Routing File',
								icon: 'vaadin:upload',
								width: 450,
								height: 315,
								listeners: {
									ready: function () {
										uploadWin.show();

										var uploadHandler = function () {

											var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

											if (!uploadField.files || uploadField.files.length < 1) {
												window.DL.MessageUtil.showOkMessage('A routing import file is required.');
											} else {
												uploadField.uploadFiles();
											}

										};

										var uploadFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-text-field',
													label: 'Note',
													name: 'note',
													maxLength: 255
												},
												{
													tag: 'vaadin-upload',
													itemid: 'uploadField',
													'no-auto': true,
													'max-files': 1,
													required: true,
													target: '/api/service/routing-tools/routing/pipeline/upload',
													headers: ImportUtil.getUploadHeader(),
													listeners: {
														'upload-request': function (event) {
															var data = uploadFormPanel.getData();
															event.detail.formData.append('note', data.note);															
														},
														'upload-success': function (event) {
															var responseData = JSON.parse(event.detail.xhr.responseText);
															if (responseData.uploadFile) {
																//error 
																window.DL.MessageUtil.showOkMessage(
																		responseData.uploadFile + '<br>' +
																		responseData.uploadFileType ? responseData.uploadFileType : ''
																		);
															} else {
																window.DL.MessageUtil.showToast('Success', 'File will be processed in the background.', {									
																	theme: 'success'
																});															
																outputGrid.refresh();
																uploadWin.close();
															}
														}
													}
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:upload', ' Upload')
																	],
																	listeners: {
																		click: function () {
																			if (uploadFormPanel.isValid()) {
																				uploadHandler();
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			uploadWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});
										uploadWin.addToContentElement(uploadFormPanel);

									}
								}


							});		
							
						};
						
					}
				}
			});
			
			
		};

		var actionRouteOptions = function() {
			var optionWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Options',
				icon: 'vaadin:cog',
				width: .75,
				height: .75,
				listeners: {
					ready: function () {
						optionWin.show();
						
						var optionPanel = ElementUtil.create({
							tag: 'dl-routing-options-form',
							slot: 'primary',
							listeners: {
								ready: function() {
									Service.getCompanyService().getCurrentCompany().then(function(companyFull){
										RoutingService.getGeospatialOptionsService().getOptions(companyFull.company.companyId).then(function(options){
											optionPanel.loadOptions(options);				
										});
									});
								}
							}
						});
						
						var buttonBar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'footer',
							theme: 'spacing',
							style: 'text-align: center; ',
							children: [								
								{
									tag: 'vaadin-button',
									itemid: 'refresh',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:check', ' Apply')
									], 
									listeners: {
										click: function() {											
											routingTool.routeOptions = optionPanel.getOptions();											
											optionWin.close();
										}
									}									
								}
							]
						});
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								optionPanel,
								buttonBar
							]
						});	
						
						optionWin.addToContentElement(layout);
						
					}
				}
			});
			
		};		
		
	}
	
}
customElements.define('dl-routing-pipeline-tool', RoutingPipelineTool);
